import { render, staticRenderFns } from "./LegendaCurvaAbcFaturamento.vue?vue&type=template&id=b0c9040e&scoped=true"
import script from "./LegendaCurvaAbcFaturamento.vue?vue&type=script&lang=js"
export * from "./LegendaCurvaAbcFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c9040e",
  null
  
)

export default component.exports